import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { isMobile } from "react-device-detect";
import { Avatar, Box, Button, Chip } from "@mui/material";
import moment from "moment";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import {
  getClassStudentsList,
  removeStudentFromClass,
} from "services/classes.service";
import Utils from "utils/index";
import Constants from "data/Constants";
import { useConfirm } from "material-ui-confirm";

const customHeaderStyle = (params) => {
  return <b>{params.colDef.headerName}</b>;
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function ViewClass() {
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const { id } = useParams();
  const { setProgress, setToast } = useOutletContext();

  const columns = [
    {
      field: "_id",
      headerName: "ID",
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return params.api.getRowIndex(params.row._id) + 1;
      },
    },

    {
      field: "fullname",
      headerName: "Student Fullname",
      width: 250,
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return (
          <Link
            to={"/dashboard/students/" + params.row._id}
            className="flex gap-2 items-center hover:underline"
          >
            {params.value}
          </Link>
        );
      },
    },

    {
      field: "dob",
      width: 250,
      headerName: "DOB",
      type: "date",
      renderHeader: customHeaderStyle,
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY"),
    },

    {
      field: "menteeName",
      headerName: "Mentee Fullname",
      width: 250,
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return (
          <Link
            to={"/dashboard/mentees/" + params.row.mentee}
            className="flex gap-2 items-center hover:underline"
          >
            <Avatar src={params.row.menteePicture} />
            {params.value ?? "Unknown"}
          </Link>
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      width: 150,
      renderHeader: customHeaderStyle,
      valueFormatter: (params) => params.value ?? "-",
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      valueFormatter: (params) => params.value ?? "-",
      renderHeader: customHeaderStyle,
    },

    {
      field: "mentee",
      headerName: "Actions",
      width: 700,
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return (
          <div className="flex gap-4">
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                confirm({
                  title: "Remove Student From Class",
                  description:
                    "Are you sure you want to remove this student from this class?",
                })
                  .then(async () => {
                    try {
                      setProgress(true);
                      await removeStudentFromClass({
                        studentId: params.row._id,
                        fromClass: id,
                      });

                      setProgress(false);
                      setToast({
                        error: false,
                        message: "Student Removed Successfully from Class",
                      });
                    } catch (error) {
                      // error
                      console.log(error);
                      setToast({
                        error: true,
                        message: Constants.Error.UNKNOWN,
                      });
                      setProgress(false);
                    }
                  })
                  .catch(() => {});
              }}
            >
              Remove
            </Button>

            <Button
              size="small"
              variant="contained"
              onClick={() => {
                navigate(
                  "/dashboard/classes/transfer/" + id + "/" + params.row._id
                );
              }}
            >
              Transfer Class
            </Button>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getClassStudentsList(id); // all students for class
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, []);

  return (
    <div className=" h-full w-full">
      <h1 className="font-bold my-2 py-2 text-lg">Students List</h1>
      <div className="w-full overflow-scroll " style={{ height: "78vh" }}>
        <DataGrid
          rows={data ?? []}
          columns={columns}
          getRowId={(row) => row._id}
          autoPageSize
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </div>
    </div>
  );
}

export default ViewClass;
